module.exports = __webpack_public_path__ + "static/ComputerScience-6c0eeafef423902f34a0c7dae1f7c76d.png";